<template>
  <div style="text-align:left;">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <ModalPerfilProfesional ref="modalPerfil" :categorias="categorias" />
      <div class="main-container">
        <div class="articulo-principal">
          <h2>Pagos pendientes</h2>
          <p class="descripcion">
            Revise el detalle de las órdenes aceptadas en nómina o con comprobantes enviados a revisión.
            El saldo pendiente corresponde a solicitudes de pago agregadas a la nómina que aún no han sido pagadas a Jobbing.
          </p>

          <div v-if="loading" class="estado">Cargando información...</div>
          <div v-else>
            <div v-if="error" class="estado estado-error">{{ error }}</div>

            <div v-if="ordenes.length">
              <div class="resumen">
                <div>
                  <strong>Total adeudado:</strong>
                  {{ formatCurrency(totalSaldoPendiente) }}
                </div>
                <div v-if="selectedOrdenIds.length">
                  <strong>Total seleccionado:</strong>
                  {{ formatCurrency(totalSeleccionado) }}
                </div>
                <button
                  class="download-button"
                  :disabled="!selectedOrdenIds.length || processingPayment || totalSeleccionado === 0"
                  @click="pagarSeleccionados"
                >
                  {{ processingPayment ? 'Enviando solicitud...' : 'Enviar comprobantes' }}
                </button>
              </div>

              <table class="tablex">
                <thead>
                  <tr>
                    <th></th>
                    <th>ID Orden</th>
                    <th>Solicitud</th>
                    <th>Dirección</th>
                    <th>Atendido por</th>
                    <th>En nómina</th>
                    <th>En revisión</th>
                    <th>Saldo pendiente</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(orden, index) in ordenes">
                    <tr
                      :key="`orden-${orden.orden_id}`"
                      :class="{ expanded: expandedIndex === index }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          :value="orden.orden_id"
                          :disabled="orden.saldo_pendiente === 0"
                          v-model="selectedOrdenIds"
                        />
                        <button class="btn-detalle" @click="toggleExpand(index)">
                          {{ expandedIndex === index ? 'Ocultar' : 'Ver' }}
                        </button>
                      </td>
                      <td>{{ orden.orden_id }}</td>
                      <td>
                        <div class="texto-principal">{{ orden.solicitud_titulo || 'Solicitud sin título' }}</div>
                        <div class="texto-secundario">#{{ orden.solicitud_id }}</div>
                      </td>
                      <td>
                        <div class="texto-principal">{{ orden.direccion || 'Sin dirección' }}</div>
                        <div class="texto-secundario">{{ orden.comuna || 'Sin comuna' }}</div>
                      </td>
                      <td>
                        <div v-if="orden.profesional" class="atendido-prof">
                          <img
                            v-if="orden.profesional.foto"
                            :src="orden.profesional.foto"
                            alt="Foto del profesional"
                            class="atendido-avatar"
                          />
                          <img
                            v-else
                            src="@/assets/empty-user.png"
                            alt="Foto del profesional"
                            class="atendido-avatar"
                          />
                          <span
                            class="link-profesional profesional-clickable"
                            @click="openProfesionalModal(orden.profesional.nombre_seo)"
                          >
                            {{ orden.profesional.nombre }} {{ orden.profesional.apellido }}
                          </span>
                        </div>
                        <span v-else>No asignado</span>
                      </td>
                      <td>{{ formatCurrency(orden.total_nomina_pendiente) }}</td>
                      <td>{{ formatCurrency(orden.total_en_revision) }}</td>
                      <td class="saldo">
                        {{ formatCurrency(orden.saldo_pendiente) }}
                      </td>
                    </tr>
                    <tr
                      v-if="expandedIndex === index"
                      :key="`detalle-${orden.orden_id}`"
                      class="detalle"
                    >
                      <td colspan="8">
                        <div class="detalle-contenido">
                          <div class="detalle-col">
                            <h4>Ítems de la orden</h4>
                            <table class="subtabla">
                              <thead>
                                <tr>
                                  <th>Ítem</th>
                                  <th>Cantidad</th>
                                  <th>Monto</th>
                                  <th>Total</th>
                                  <th>Estado</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in orden.items" :key="item.id">
                                  <td>{{ item.nombre }}</td>
                                  <td>{{ item.cantidad }}</td>
                                  <td>{{ formatCurrency(item.precio) }}</td>
                                  <td>{{ formatCurrency(item.total) }}</td>
                                  <td>{{ item.realizado ? 'Realizado' : 'Pendiente' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="detalle-col">
                            <h4>Pagos registrados</h4>
                            <div v-if="orden.pagos && orden.pagos.length">
                              <table class="subtabla">
                                <thead>
                                  <tr>
                                    <th>ID Pago</th>
                                    <th>Monto</th>
                                    <th>Estado</th>
                                    <th>Fecha</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="pago in orden.pagos" :key="pago.id">
                                    <td>{{ pago.id }}</td>
                                    <td>{{ formatCurrency(pago.monto) }}</td>
                                    <td>{{ estadoPago(pago.estado) }}</td>
                                    <td>{{ formatFecha(pago.fecha_pagado) }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-else class="sin-datos">No hay pagos registrados.</div>
                          </div>
                          <div class="detalle-col">
                            <h4>Solicitudes de pago agrupado</h4>
                            <div
                              v-if="orden.solicitudes_pago_agrupado && orden.solicitudes_pago_agrupado.length"
                              class="solicitudes-grid"
                            >
                              <div
                                v-for="solicitud in orden.solicitudes_pago_agrupado"
                                :key="`solicitud-${orden.orden_id}-${solicitud.id}`"
                                class="solicitud-card"
                              >
                                <div class="solicitud-header">
                                  <span class="solicitud-id">Solicitud #{{ solicitud.id }}</span>
                                  <span class="estado-chip" :class="`estado-${solicitud.estado}`">
                                    {{ estadoSolicitudAgrupado(solicitud.estado) }}
                                  </span>
                                </div>
                                <div class="solicitud-body">
                                  <div class="solicitud-row">
                                    <span class="label">Monto enviado:</span>
                                    <span>{{ formatCurrency(solicitud.monto_total) }}</span>
                                  </div>
                                  <div class="solicitud-row" v-if="solicitud.fecha_creado">
                                    <span class="label">Enviada:</span>
                                    <span>{{ formatFecha(solicitud.fecha_creado) }}</span>
                                  </div>
                                  <div class="solicitud-row" v-if="solicitud.fecha_resuelto">
                                    <span class="label">Actualizada:</span>
                                    <span>{{ formatFecha(solicitud.fecha_resuelto) }}</span>
                                  </div>
                                  <div class="solicitud-row" v-if="solicitud.notas">
                                    <span class="label">Notas:</span>
                                    <span>{{ solicitud.notas }}</span>
                                  </div>
                                  <div class="solicitud-row" v-if="solicitud.observaciones_revision">
                                    <span class="label">Observaciones:</span>
                                    <span>{{ solicitud.observaciones_revision }}</span>
                                  </div>
                                  <div
                                    v-if="solicitud.comprobantes && solicitud.comprobantes.length"
                                    class="solicitud-comprobantes"
                                  >
                                    <span class="label">Comprobantes:</span>
                                    <ul>
                                      <li
                                        v-for="comprobante in solicitud.comprobantes"
                                        :key="`comprobante-${comprobante.id}`"
                                      >
                                        <a
                                          v-if="comprobante.url_descarga"
                                          :href="comprobante.url_descarga"
                                          target="_blank"
                                          rel="noopener"
                                        >
                                          {{ comprobante.nombre_archivo || 'Archivo' }}
                                        </a>
                                        <span v-else>{{ comprobante.nombre_archivo || 'Archivo' }}</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else class="sin-datos">No hay solicitudes asociadas.</div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div v-else class="estado">No hay pagos pendientes registrados.</div>
          </div>
        </div>
      </div>
    </div>
    <transition name="modal-fade">
      <div v-if="showPaymentModal" class="modal-overlay">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Enviar comprobantes de pago</h3>
            <button type="button" class="close-btn" @click="cerrarModalPago" :disabled="processingPayment">
              ×
            </button>
          </div>
          <form class="modal-form" @submit.prevent="confirmarPago">
            <div class="modal-body">
              <p class="modal-intro">
                Se enviará una solicitud de revisión por {{ ordenesSeleccionadas.length }}
                {{ ordenesSeleccionadas.length === 1 ? 'orden' : 'órdenes' }}.
              </p>
              <ul class="modal-ordenes">
                <li v-for="orden in ordenesSeleccionadas" :key="`resumen-${orden.orden_id}`">
                  <span>Orden #{{ orden.orden_id }}</span>
                  <span>{{ formatCurrency(orden.saldo_pendiente) }}</span>
                </li>
              </ul>
              <div class="input-group">
                <label for="payment-notes">Notas (opcional)</label>
                <textarea
                  id="payment-notes"
                  v-model="paymentNotes"
                  rows="3"
                  placeholder="Añada detalles relevantes sobre la transferencia"
                  :disabled="processingPayment"
                ></textarea>
              </div>
              <div class="input-group">
                <label :for="`comprobantes-${fileInputKey}`">Comprobantes</label>
                <input
                  :id="`comprobantes-${fileInputKey}`"
                  :key="fileInputKey"
                  type="file"
                  multiple
                  @change="onFileChange"
                  :disabled="processingPayment"
                />
              </div>
              <div v-if="paymentFiles.length" class="file-list">
                <div class="file-item" v-for="(archivo, index) in paymentFiles" :key="`${archivo.name}-${index}`">
                  <span>{{ archivo.name }}</span>
                  <button
                    type="button"
                    class="link-button"
                    @click="removeFile(index)"
                    :disabled="processingPayment"
                  >
                    Quitar
                  </button>
                </div>
              </div>
              <div v-else class="file-empty">Debe adjuntar al menos un comprobante.</div>
              <div class="modal-summary">
                <span>Total a enviar:</span>
                <strong>{{ formatCurrency(totalSeleccionado) }}</strong>
              </div>
              <div v-if="paymentError" class="modal-error">{{ paymentError }}</div>
            </div>
            <div class="modal-actions">
              <button type="button" class="btn-secondary" @click="cerrarModalPago" :disabled="processingPayment">
                Cancelar
              </button>
              <button type="submit" class="btn-primary" :disabled="!canSubmitPayment">
                {{ processingPayment ? 'Enviando...' : 'Enviar para revisión' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';
import ModalPerfilProfesional from '@/components/ModalPerfilProfesional.vue';

export default {
  name: 'PagosPendientes',
  components: {
    SideNav,
    TopNav,
    ModalPerfilProfesional,
  },
  data() {
    return {
      ordenes: [],
      loading: false,
      error: null,
      expandedIndex: null,
      selectedOrdenIds: [],
      processingPayment: false,
      showPaymentModal: false,
      paymentNotes: '',
      paymentFiles: [],
      paymentError: null,
      fileInputKey: 0,
    };
  },
  computed: {
    ...mapGetters(['admin_datos', 'categorias']),
    totalSaldoPendiente() {
      return this.ordenes.reduce((acc, orden) => acc + (orden.saldo_pendiente || 0), 0);
    },
    totalSeleccionado() {
      return this.ordenes
        .filter((orden) => this.selectedOrdenIds.includes(orden.orden_id))
        .reduce((acc, orden) => acc + (orden.saldo_pendiente || 0), 0);
    },
    ordenesSeleccionadas() {
      return this.ordenes.filter((orden) => this.selectedOrdenIds.includes(orden.orden_id));
    },
    canSubmitPayment() {
      return (
        this.showPaymentModal &&
        this.selectedOrdenIds.length > 0 &&
        this.totalSeleccionado > 0 &&
        this.paymentFiles.length > 0 &&
        !this.processingPayment
      );
    },
  },
  methods: {
    ...mapActions(['updatePropertyManagerPendingPaymentsFromOrders']),
    fetchDeudas() {
      this.loading = true;
      this.error = null;
      axios
        .get(`${window.hostname}api/property_manager/deudas_items`)
        .then((response) => {
          this.ordenes = response.data.ordenes || [];
          const ordenesConSaldo = new Set(
            this.ordenes.filter((orden) => (orden.saldo_pendiente || 0) > 0).map((orden) => orden.orden_id)
          );
          this.selectedOrdenIds = this.selectedOrdenIds.filter((id) => ordenesConSaldo.has(id));
          this.updatePropertyManagerPendingPaymentsFromOrders(this.ordenes);
        })
        .catch((err) => {
          console.error('Error obteniendo deudas:', err);
          this.error = 'No fue posible cargar la información. Intente nuevamente en unos minutos.';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleExpand(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    openProfesionalModal(nombreSeo) {
      if (!nombreSeo || !this.$refs.modalPerfil) {
        return;
      }
      this.$refs.modalPerfil.openByNombreSeo(nombreSeo);
    },
    formatCurrency(value) {
      if (value === null || value === undefined) {
        return '$0';
      }
      const numberValue = Number(value) || 0;
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
      }).format(numberValue);
    },
    formatFecha(value) {
      if (!value) {
        return 'Sin fecha';
      }
      const fecha = new Date(value);
      if (Number.isNaN(fecha.getTime())) {
        return 'Fecha inválida';
      }
      return fecha.toLocaleDateString('es-CL');
    },
    estadoPago(estado) {
      const labels = {
        0: 'Pendiente',
        1: 'Pagado',
        2: 'Rechazado',
        3: 'En revisión',
      };
      return labels[estado] || 'Desconocido';
    },
    estadoSolicitudAgrupado(estado) {
      const labels = {
        0: 'Pendiente',
        1: 'Aprobado',
        2: 'Rechazado',
        3: 'En revisión',
      };
      return labels[estado] || 'Desconocido';
    },
    pagarSeleccionados() {
      if (
        !this.selectedOrdenIds.length ||
        this.processingPayment ||
        this.totalSeleccionado === 0
      ) {
        return;
      }

      this.paymentError = null;
      this.showPaymentModal = true;
    },
    cerrarModalPago() {
      if (this.processingPayment) {
        return;
      }
      this.showPaymentModal = false;
      this.resetPaymentForm();
    },
    resetPaymentForm() {
      this.paymentNotes = '';
      this.paymentFiles = [];
      this.paymentError = null;
      this.fileInputKey += 1;
    },
    onFileChange(event) {
      const archivos = Array.from(event.target.files || []);
      this.paymentFiles = archivos;
      this.paymentError = null;
    },
    removeFile(index) {
      if (index < 0 || index >= this.paymentFiles.length) {
        return;
      }
      this.paymentFiles.splice(index, 1);
      if (!this.paymentFiles.length) {
        this.fileInputKey += 1;
      }
    },
    confirmarPago() {
      if (!this.selectedOrdenIds.length) {
        this.paymentError = 'Debe seleccionar al menos una orden.';
        return;
      }

      if (this.totalSeleccionado === 0) {
        this.paymentError = 'Las órdenes seleccionadas no tienen saldo pendiente.';
        return;
      }

      if (!this.paymentFiles.length) {
        this.paymentError = 'Adjunte al menos un comprobante para continuar.';
        return;
      }

      const formData = new FormData();
      formData.append('orden_ids', JSON.stringify(this.selectedOrdenIds));
      if (this.paymentNotes && this.paymentNotes.trim().length) {
        formData.append('notas', this.paymentNotes.trim());
      }
      this.paymentFiles.forEach((archivo) => {
        formData.append('comprobantes', archivo);
      });

      this.paymentError = null;
      this.processingPayment = true;
      axios
        .post(`${window.hostname}api/property_manager/pagar_items`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          const total = response.data?.monto_total || 0;
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Solicitud enviada',
            text: `Se envió la solicitud con comprobantes por ${this.formatCurrency(total)}.`,
          });
          this.showPaymentModal = false;
          this.resetPaymentForm();
          this.selectedOrdenIds = [];
          this.fetchDeudas();
        })
        .catch((err) => {
          console.error('Error al registrar pagos:', err);
          const mensaje = err?.response?.data?.error || 'No se pudieron registrar los pagos seleccionados.';
          this.paymentError = mensaje;
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: mensaje,
          });
        })
        .finally(() => {
          this.processingPayment = false;
        });
    },
  },
  mounted() {
    if (!this.admin_datos || this.admin_datos.user_type !== 'property_manager') {
      this.$router.push('/');
      return;
    }
    this.fetchDeudas();
  },
};
</script>

<style scoped>
.column-right {
  background-color: #f2f7fb;
  padding-top: 80px;
  padding-left: 260px;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}

.main-container {
  background-color: #fff;
  margin: 20px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.articulo-principal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.articulo-principal h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.download-button {
  background-color: #007bff;
  border: none;
  color: #fff;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease-in-out;
}

.download-button:disabled {
  background-color: #aac9f4;
  cursor: not-allowed;
}

.download-button:not(:disabled):hover {
  background-color: #005fcc;
}

.descripcion {
  margin-bottom: 15px;
  color: #555;
}

.estado {
  padding: 12px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-top: 10px;
}
.estado-error {
  background: #ffefef;
  color: #c0392b;
}

.resumen {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.resumen button {
  margin-left: auto;
}

.tablex {
  width: 100%;
  border-collapse: collapse;
}

.tablex th,
.tablex td {
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}

.tablex thead {
  background: #fafafa;
}

.tablex tr.expanded {
  background: #f9f9f9;
}

.btn-detalle {
  margin-left: 8px;
  border: none;
  background: transparent;
  color: #007bff;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-detalle:hover {
  text-decoration: underline;
}

.detalle {
  background: #fff;
}

.atendido-prof {
  display: flex;
  align-items: center;
  gap: 10px;
}

.atendido-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e0e0e0;
}

.link-profesional {
  color: #007bff;
  cursor: pointer;
  font-weight: 600;
}

.link-profesional:hover {
  text-decoration: underline;
}

.subtabla {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.subtabla th,
.subtabla td {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.subtabla thead {
  background: #f1f1f1;
}

.sin-datos {
  padding: 10px 0;
  color: #777;
}

.saldo {
  font-weight: 700;
  color: #c0392b;
}

.saldo-secundario {
  margin-top: 4px;
  font-size: 12px;
  color: #4a6fa5;
}

.detalle-contenido {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.detalle-col {
  flex: 1 1 280px;
}

.solicitudes-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.solicitud-card {
  border: 1px solid #d8e2ef;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.solicitud-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.solicitud-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.solicitud-id {
  font-weight: 600;
  color: #2f4f6f;
}

.estado-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.estado-0 {
  background: #e9f1ff;
  color: #2b63c0;
}

.estado-1 {
  background: #e1f5ec;
  color: #1f7a4d;
}

.estado-2 {
  background: #fdecea;
  color: #b23b3b;
}

.estado-3 {
  background: #fff8e1;
  color: #c27d0e;
}

.solicitud-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 14px;
  margin-bottom: 6px;
}

.solicitud-row .label {
  font-weight: 600;
  color: #4a4a4a;
}

.solicitud-comprobantes ul {
  margin: 6px 0 0;
  padding-left: 18px;
}

.solicitud-comprobantes a {
  color: #007bff;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-container {
  background: #ffffff;
  border-radius: 12px;
  width: 640px;
  max-width: 90vw;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
}

.close-btn {
  border: none;
  background: none;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  color: #8592a6;
}

.close-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.modal-form {
  display: flex;
  flex-direction: column;
}

.modal-body {
  padding: 12px 24px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-intro {
  margin: 0;
  color: #4a5568;
}

.modal-ordenes {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #e5edf6;
  border-radius: 8px;
  overflow: hidden;
}

.modal-ordenes li {
  display: flex;
  justify-content: space-between;
  padding: 10px 14px;
  font-size: 14px;
}

.modal-ordenes li:nth-child(odd) {
  background: #f7fbff;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-group label {
  font-weight: 600;
  color: #374151;
}

.input-group textarea {
  resize: vertical;
  min-height: 90px;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-family: inherit;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f3f6fb;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
}

.file-empty {
  font-size: 13px;
  color: #9aa4b2;
}

.link-button {
  background: none;
  border: none;
  color: #1d4ed8;
  cursor: pointer;
  padding: 0;
}

.link-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.modal-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f7fbff;
  border-radius: 8px;
  font-size: 15px;
}

.modal-summary strong {
  color: #1f4b8c;
}

.modal-error {
  background: #fdecea;
  color: #a13a3a;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 24px 24px;
}

.btn-primary,
.btn-secondary {
  border: none;
  border-radius: 6px;
  padding: 10px 18px;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary {
  background: #2563eb;
  color: #fff;
}

.btn-primary:disabled {
  background: #93b5fd;
  cursor: not-allowed;
}

.btn-secondary {
  background: #e5edf6;
  color: #1e3a8a;
}

.btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .column-right {
    padding-left: 0;
    padding-top: 90px;
    padding-right: 15px;
  }

  .resumen {
    flex-direction: column;
    align-items: flex-start;
  }

  .resumen button {
    width: 100%;
    margin-left: 0;
  }

  .detalle-contenido {
    flex-direction: column;
  }
}
</style>
